<template>
<div class="netorigional">
<h2 class="netflix-origional-header">Netflix Origional</h2>
<div class="netflexorigional">
     
  <div class="netflix-origional netforigional">
     
  <!--   netflixOrigional    start -->
     <div class="netflex original" v-for=" (origional,index) in origionals"  v-bind:key="index" :origional="origional">
      <!-- <Netflixorigional v-for=" (origional,index) in origionals"  v-bind:key="index" :netflixorigional="netflixorigional" />  -->
      
          <div class="netflix-original-images mediumimage">
              
              <div class="origional-section">
                  
                <img :src="`https://image.tmdb.org/t/p/original`+`${origional.backdrop_path}`">
                <!-- <p> {{ origional.original_name}} </p> -->
                <div class="desc-part">
                    <div class="icon">
                        <img src="../images/play-solid.svg">
                        <img src="../images/plus-circle-solid.svg">
                        <img src="../images/thumbs-up-solid.svg">
                        <img src="../images/thumbs-down-solid.svg">
                    </div>
                    <div class="desc-sec">
                        <span class="match" style="color:green">{{origional.vote_average}}% Match</span>
                        <span>{{ origional.overview }}</span>
                    </div>
                 </div>
              </div> 
          </div>
     </div>
  </div>
</div>
</div>
</template>

<script>
import axios from 'axios';
const API_KEY = "c20644006c1a56f0c5eca8d53b6ccf4e";
export default {
   data(){
       return{
           origionals:[],
        
       }
   },
   created(){
        // origonal
       axios.get(`https://api.themoviedb.org/3/discover/tv?api_key=${API_KEY}&with_networks=213`)
            .then(resorigioal => {
             var origionals = resorigioal.data.results;
             console.log("origionals:",origionals)
             this.origionals=origionals;
             this.postarimage = origionals.backdrop_path;
            
            })
   }
}
</script>

<style scoped>
.netorigional{
    margin-top: -3vw;
}
.netflix-origional-header{
    color: white;
}
.netflix-original{
    margin-top: 0vw;
    display: flex;
    flex-direction: row;
    overflow: auto;
}
.netforigional{
    overflow: auto;
    display: flex;
    padding: 3vw 0 20vw 0;
    margin-top: -2vw;
}
.netflix-origional::-webkit-scrollbar,.netflix-trending::-webkit-scrollbar{
    display: none;
}
   
   .netflix-original-images{
       width:15vw;
       height:10vw;
       margin-left: 0.2vw;
       /* transition: 0.4s all linear; */
       
       transform: scale(1);
   }
   .netflix-original-images p{
        top: 20%;
        position: absolute;
        transform: translateY(-20%);
        width: 100%;
        color:white;
        font-size: 1vw;
        text-align: center;
        font-family: 'Rock Salt', cursive;
   }
   .original .netflix-original-images{
        width: 15vw;
        height: 13vw;
        z-index: -10;
   }
   
   .original{
       transition: transform .3s;
   }
   .original:hover{
        transform: scale(1.2);
        z-index: 5000;
   }
   
.title-image{
    position: absolute;
    top:60%;
    left:10%;
    transform: translate(-10%,-60%);
    width:300px;
    overflow: hidden;
}
.title-image img{
    width: 100%;
    height: 100%;
}
.origional-section img{
      height: 100%;
        width: 100%;
        object-fit: contain;
        object-position: center;
  }
  .original:hover  .desc-part{
        visibility: visible;
  }
  .desc-part{
      background: black;
      margin-top:-0.3vw;
     visibility: hidden;
  }
  .desc-part .icon{
   padding: 20px;
   overflow: hidden;
   display: flex;

  }
  .desc-part .icon img{
      height: 1vw;
      width: 1vw;
      border:1px solid white;
      border-radius: 50%;
      padding: 0.5vw;
      margin-left: 10px;
  }
  .desc-sec{
      padding: 0 1vw 1vw 1vw;
  }
  .desc-sec span{
      font-size: 10px;
      color: white;
      margin-top:0vw;
  }
  .match{
      color:green;
      display: block;
      font-weight: 700;
  }
</style>